import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// import { DataTablesModule } from 'angular-datatables';
import { AppRoutingModule } from '../app.routing';
import { CodeComponent } from './code/code.component';
import { IpcaptureComponent } from './ipcapture.component';
import { QuestionsComponent } from './questions/questions.component';
import { Questions1Component } from './questions1/questions1.component';
import { RecoverycoachComponent } from './recoverycoach/recoverycoach.component';
import { RecoverypatComponent } from './recoverypat/recoverypat.component';
import { SecurityComponent } from './security/security.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
    imports: [
        CommonModule,
        // DataTablesModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
          }
        }),
    ],
    declarations: [
        IpcaptureComponent,
        RecoverycoachComponent,
        RecoverypatComponent,
        Questions1Component,
        QuestionsComponent,
        SecurityComponent,
        CodeComponent
    ]
})
export class IpcaptureModule { }
